import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    email: yup.string().trim().required().email().label('Email').required(),
    phone: yup.string().trim().required().label('Phone').phone(),
    first_name: yup.string().trim().required().label('First Name'),
    last_name: yup.string().trim().required().label('Last name'),
    shipper_name: yup.string().trim().required().label('Business Name')
  });
};
